/*
 * Grocera – ca aplicația (tema de test, 04.10.2026, a treia rundă). Aspectul e în assets/grocera-ca-aplicatia-3.css.
 * - Calculator, pagina produsului ca în aplicație: „Înapoi” devine X-ul verde (înapoi de unde ai venit, altfel în
 *   categoria produsului), „Trimite” în dreapta căii (fără inimă: favoritele nu mai sunt pe site, 04.10.2026),
 *   descrierea și „Informații nutriționale” în cutii albe care se deschid pe loc, în coloana din dreapta, după buton.
 * - Calculator: iconița de cont din antet (și „Autentificare / Înregistrare” din meniu) deschide „Contul meu”
 *   (/?view=cont), ca tabul Cont din aplicație; pastilele subcategoriilor primesc săgeți când nu încap pe ecran (fără
 *   trackpad nu le puteai derula).
 * - Telefon și aplicația veche (Natively): footerul stă ascuns la capătul paginii. Prima derulare se oprește acolo;
 *   abia încă una în jos (sau apăsarea pe „Program, contact și termeni”) îl arată.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var desktop = window.matchMedia('(min-width: 768px)');
  var phone = window.matchMedia('(max-width: 767px)');

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function svg(paths, extraClass) {
    return (
      '<svg' + (extraClass ? ' class="' + extraClass + '"' : '') +
      ' viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="' + paths + '"/></svg>'
    );
  }

  // Iconițele aplicației (Material Design Icons, Apache 2.0), aceleași ca în bara de sus de pe telefon.
  var ICON_CLOSE = 'M18.98 6.42 17.58 5.02 12 10.59 6.42 5.02 5.02 6.42 10.59 12 5.02 17.58 6.42 18.98 12 13.41 17.58 18.98 18.98 17.58 13.41 12Z';
  var ICON_SHARE_IOS = 'M12 0.98 8.02 5.02H11.02V14.02H12.98V5.02H15.98ZM18 23.02H6Q5.16 23.02 4.57 22.43Q3.98 21.84 3.98 21V9Q3.98 8.16 4.57 7.57Q5.16 6.98 6 6.98H9V9H6V21H18V9H15V6.98H18Q18.84 6.98 19.43 7.57Q20.02 8.16 20.02 9V21Q20.02 21.84 19.43 22.43Q18.84 23.02 18 23.02Z';
  var ICON_SHARE_ALT = 'M18 16.08Q16.88 16.08 16.03 16.83L8.91 12.7Q9 12.28 9 12Q9 11.72 8.91 11.3L15.94 7.17Q16.83 8.02 18.05 8.02Q19.27 8.02 20.13 7.12Q21 6.23 21 4.99Q21 3.75 20.13 2.88Q19.27 2.02 18 2.02Q16.73 2.02 15.87 2.88Q15 3.75 15 5.02Q15 5.3 15.09 5.72L8.06 9.8Q7.17 9 5.95 9Q4.73 9 3.87 9.87Q3 10.73 3 12Q3 13.27 3.87 14.13Q4.73 15 5.95 15Q7.17 15 8.06 14.2L15.14 18.33Q15.09 18.66 15.09 18.98Q15.09 20.2 15.94 21.05Q16.78 21.89 18 21.89Q19.22 21.89 20.06 21.05Q20.91 20.2 20.91 19.01Q20.91 17.81 20.06 16.95Q19.22 16.08 18 16.08ZM18 3.98Q18.42 3.98 18.7 4.29Q18.98 4.59 18.98 4.99Q18.98 5.39 18.7 5.7Q18.42 6 18 6Q17.58 6 17.3 5.7Q17.02 5.39 17.02 4.99Q17.02 4.59 17.3 4.29Q17.58 3.98 18 3.98ZM6 12.98Q5.58 12.98 5.3 12.7Q5.02 12.42 5.02 12Q5.02 11.58 5.3 11.3Q5.58 11.02 6 11.02Q6.42 11.02 6.7 11.3Q6.98 11.58 6.98 12Q6.98 12.42 6.7 12.7Q6.42 12.98 6 12.98ZM18 20.02Q17.58 20.02 17.3 19.71Q17.02 19.41 17.02 19.01Q17.02 18.61 17.3 18.3Q17.58 18 18 18Q18.42 18 18.7 18.3Q18.98 18.61 18.98 19.01Q18.98 19.41 18.7 19.71Q18.42 20.02 18 20.02Z';
  var ICON_LEFT = 'M15.41 16.58 10.83 12 15.41 7.41 14 6 8 12 14 18Z';
  var ICON_RIGHT = 'M8.59 16.58 13.17 12 8.59 7.41 10 6 16 12 10 18Z';

  /* ───────── Calculator: pagina produsului ───────── */

  // Înapoi de unde ai venit, dacă e tot de pe site; altfel în categoria produsului (sau la Produse).
  function goBack(fallback) {
    var sameSite = false;
    try {
      sameSite = !!document.referrer && new URL(document.referrer).origin === location.origin;
    } catch (error) {
      sameSite = false;
    }
    if (sameSite && history.length > 1) history.back();
    else location.href = fallback || '/collections';
  }

  var toastTimer = null;
  function toast(text) {
    var box = document.querySelector('.ga-toast');
    if (!box) {
      box = document.createElement('div');
      box.className = 'ga-toast';
      box.setAttribute('role', 'status');
      box.setAttribute('aria-live', 'polite');
      document.body.appendChild(box);
    }
    box.textContent = text;
    // Un cadru întâi, ca tranziția să pornească și la primul anunț.
    requestAnimationFrame(function () {
      box.classList.add('is-on');
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      box.classList.remove('is-on');
    }, 2400);
  }

  function copyLink(url) {
    var done = function () {
      toast('Linkul produsului e copiat');
    };
    var legacy = function () {
      var field = document.createElement('textarea');
      field.value = url;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      try {
        document.execCommand('copy');
        done();
      } catch (error) {
        toast(url);
      }
      field.remove();
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, legacy);
    else legacy();
  }

  function share() {
    var url = location.href.split('#')[0];
    if (navigator.share) {
      navigator.share({ title: document.title, url: url }).catch(function (error) {
        // Închis de om: nimic. Altă eroare (fără „Trimite” în sistem): copiem linkul.
        if (!error || error.name !== 'AbortError') copyLink(url);
      });
      return;
    }
    copyLink(url);
  }

  function actions(crumbs) {
    var wrap = document.createElement('div');
    wrap.className = 'ga-desk-actions' + (/Mac|iPhone|iPad/.test(navigator.userAgent) ? ' ga-mac' : '');
    wrap.innerHTML =
      '<button type="button" class="ga-round" data-ga-desk-share aria-label="Trimite produsul" title="Trimite">' +
      svg(ICON_SHARE_IOS, 'ga-share-ios') + svg(ICON_SHARE_ALT, 'ga-share-alt') +
      '</button>';
    crumbs.parentNode.appendChild(wrap);

    // Fără inimă: favoritele nu mai sunt pe site (Zoli, 04.10.2026), rămân doar în aplicație.
    wrap.addEventListener('click', function (event) {
      if (event.target.closest('[data-ga-desk-share]')) {
        event.preventDefault();
        share();
      }
    });
  }

  function backButton(crumbs) {
    var back = crumbs.querySelector('.breadcrumbs__back');
    if (!back || back.classList.contains('ga-x')) return;
    var cats = crumbs.querySelectorAll('a.reversed-link:not([href="/"])');
    var fallback = cats.length ? cats[cats.length - 1].getAttribute('href') : '/collections';
    back.classList.add('ga-x');
    back.removeAttribute('onclick');
    back.onclick = null;
    back.setAttribute('aria-label', 'Înapoi');
    back.setAttribute('title', 'Înapoi');
    back.insertAdjacentHTML('afterbegin', svg(ICON_CLOSE, 'ga-x__icon'));
    back.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      goBack(fallback);
    });
  }

  // O cutie albă care se deschide pe loc: titlul (buton) și conținutul.
  function fold(block, title, content, open) {
    var head = document.createElement('button');
    head.type = 'button';
    head.className = 'ga-fold-head';
    head.textContent = title;
    var body = document.createElement('div');
    body.className = 'ga-fold-body';
    body.appendChild(content);
    block.insertBefore(body, block.firstChild);
    block.insertBefore(head, body);
    block.classList.add('ga-dfold');
    var set = function (value) {
      block.classList.toggle('is-open', value);
      head.setAttribute('aria-expanded', value ? 'true' : 'false');
    };
    set(!!open);
    head.addEventListener('click', function () {
      set(!block.classList.contains('is-open'));
    });
  }

  function productDesk() {
    var section = document.querySelector('.section-main-product');
    if (!section || !desktop.matches) return;
    root.classList.add('ga-desk-product');

    var crumbs = document.querySelector('.section-breadcrumb > .breadcrumbs');
    if (crumbs) {
      backButton(crumbs);
      if (!crumbs.parentNode.querySelector('.ga-desk-actions')) actions(crumbs);
    }

    // Descrierea și „Informații nutriționale” ale telefonului (cele din coloana din dreapta), ca cutii care se
    // deschid pe loc; cele de sub poză se ascund (CSS). Puse după „Adaugă în coș”, înaintea produselor recomandate.
    var blocks = section.querySelector('.product__info-container .product__blocks');
    if (!blocks) return;
    var anchor = blocks.querySelector('.product__block--complementary');
    var place = function (block) {
      if (anchor && anchor.parentNode === blocks) blocks.insertBefore(block, anchor);
      else blocks.appendChild(block);
    };

    var description = blocks.querySelector('.product__block--description[class~="md:hidden"]');
    if (description && !description.classList.contains('ga-dfold')) {
      var heading = description.querySelector('.product__description-heading');
      var text = description.querySelector('.rte');
      if (text) {
        if (heading) heading.hidden = true;
        fold(description, (heading && heading.textContent.trim()) || 'Descriere', text, true);
        place(description);
      }
    }

    var nutrition = blocks.querySelector('.product__block--nutritional_info_popup[class~="md:hidden"]');
    if (nutrition && !nutrition.classList.contains('ga-dfold')) {
      var trigger = nutrition.querySelector('.nutrition-popup__trigger');
      var table = nutrition.querySelector('.drawer__body .rte');
      if (table) {
        var label = trigger ? trigger.textContent.trim() : '';
        fold(nutrition, label || 'Informații nutriționale', table.cloneNode(true), false);
        place(nutrition);
      }
    }
  }

  /* ───────── Calculator: contul și săgețile pastilelor ───────── */

  // Contul ca în aplicație: „Contul meu” (/?view=cont) în loc de contul Shopify (account.grocera.ro); de acolo se
  // ajunge la login, la comenzi și la datele personale. Nu și în aplicația veche, care își are drumurile ei.
  function accountLinks() {
    if (root.classList.contains('ga-natively')) return;
    var target = '/?view=cont';
    each(document.querySelectorAll('a.account-button'), function (link) {
      link.setAttribute('href', target);
    });
    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest && event.target.closest('a.account-button');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        location.href = target;
      },
      true
    );
  }

  // Săgeți la pastilele care nu încap pe ecran: o apăsare mută rândul cu cât se vede din el.
  function tabArrows() {
    if (!desktop.matches) return;
    each(document.querySelectorAll('.collection-template .subcategory-tabs-wrapper'), function (wrapper) {
      var row = wrapper.querySelector('.subcategory-tabs');
      if (!row || row.querySelector('.ga-tabs-arrow')) return;
      var make = function (dir) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ga-tabs-arrow ga-tabs-arrow--' + dir;
        button.setAttribute('aria-label', dir === 'prev' ? 'Categoriile de dinainte' : 'Mai multe categorii');
        button.innerHTML = '<span class="ga-tabs-arrow__dot">' + svg(dir === 'prev' ? ICON_LEFT : ICON_RIGHT) + '</span>';
        button.hidden = true;
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var step = Math.max(240, wrapper.clientWidth * 0.7);
          wrapper.scrollBy({ left: dir === 'prev' ? -step : step, behavior: 'smooth' });
        });
        return button;
      };
      var prev = make('prev');
      var next = make('next');
      row.insertBefore(prev, row.firstChild);
      row.appendChild(next);
      var update = function () {
        var max = wrapper.scrollWidth - wrapper.clientWidth;
        prev.hidden = wrapper.scrollLeft <= 4;
        next.hidden = max <= 4 || wrapper.scrollLeft >= max - 4;
      };
      wrapper.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      requestAnimationFrame(update);
      setTimeout(update, 800);
    });
  }

  /* ───────── Telefon: footerul la a doua derulare ───────── */

  function footerGate() {
    if (!phone.matches) return;
    var groups = document.querySelectorAll('.shopify-section-group-footer-group');
    if (!groups.length) return;
    var first = groups[0];

    var pull = document.createElement('button');
    pull.type = 'button';
    pull.className = 'ga-foot-pull';
    pull.textContent = 'Program, contact și termeni';
    first.parentNode.insertBefore(pull, first);

    root.classList.add('ga-foot-gate');

    var opened = false;
    var open = function (scroll) {
      if (opened) return;
      opened = true;
      root.classList.remove('ga-foot-pulling');
      root.classList.add('ga-foot-open');
      if (scroll) {
        requestAnimationFrame(function () {
          var top = first.getBoundingClientRect().top + window.scrollY - window.innerHeight * 0.35;
          window.scrollTo({ top: Math.max(top, window.scrollY), behavior: 'smooth' });
        });
      }
    };
    pull.addEventListener('click', function () {
      open(true);
    });

    // „La capăt” = ultimul ecran al paginii; „oprit acolo” = n-ai mai derulat de un sfert de secundă.
    var atEnd = function () {
      var doc = document.documentElement;
      return window.innerHeight + window.scrollY >= Math.max(doc.scrollHeight, document.body.scrollHeight) - 6;
    };
    var parked = false;
    var parkTimer = null;
    window.addEventListener(
      'scroll',
      function () {
        parked = false;
        clearTimeout(parkTimer);
        if (opened || !atEnd()) return;
        parkTimer = setTimeout(function () {
          if (atEnd()) parked = true;
        }, 250);
      },
      { passive: true }
    );

    // Încă o derulare în jos de la capăt: degetul urcă pe ecran (sau rotița în jos).
    var startY = null;
    var armed = false;
    window.addEventListener(
      'touchstart',
      function (event) {
        if (opened || !event.touches || event.touches.length !== 1) return;
        startY = event.touches[0].clientY;
        armed = parked && atEnd();
      },
      { passive: true }
    );
    window.addEventListener(
      'touchmove',
      function (event) {
        if (opened || !armed || startY === null || !event.touches) return;
        var pulled = startY - event.touches[0].clientY;
        root.classList.toggle('ga-foot-pulling', pulled > 12);
        if (pulled > 56) open(true);
      },
      { passive: true }
    );
    window.addEventListener(
      'touchend',
      function () {
        startY = null;
        armed = false;
        root.classList.remove('ga-foot-pulling');
      },
      { passive: true }
    );
    window.addEventListener(
      'wheel',
      function (event) {
        if (!opened && parked && atEnd() && event.deltaY > 8) open(true);
      },
      { passive: true }
    );
    // O pagină mai scurtă decât ecranul e deja la capăt: o tragere în sus arată footerul.
    if (atEnd()) parked = true;
  }

  /* ───────── Coșul: cât e produsul, sub nume (a cincea rundă, 04.10.2026) ───────── */

  /*
   * Zoli: „să apară gramajul în coș”. Ca în coșul aplicației (grocera-app, src/lib/product/pack-size.ts, aceleași reguli):
   * „150 g”, „ca. 350 g”, „6 × 1,5 L”, „8 buc.”. Titlul întâi (măsura Shopify e uneori greșită: „Apă 0.75L” cu 0,7 L),
   * apoi măsura Shopify (data-ga-masura, din snippets/cart-item-row.liquid), apoi tag-ul „Gramaj:…”. Pe telefon și pe
   * calculator; tema reface rândurile la fiecare schimbare de cantitate, deci eticheta se pune din nou.
   */
  var SIZE_NUM = '(\\d+(?:[.,]\\d+)?)';
  var SIZE_UNIT = '(kg|g|ml|cl|l)';
  var SIZE_START = '(?:^|[^\\w.,<>+])';
  var SIZE_NOT_NUTRIENT = '(?!\\s*(?:de\\s+)?(?:protein|zah[aă]r|gr[aă]sim|fibre|carbohidra|sare\\b))';
  var SIZE_MULTI = new RegExp(SIZE_START + '(\\d+)\\s*[x×]\\s*' + SIZE_NUM + '\\s*' + SIZE_UNIT + '\\b', 'i');
  var SIZE_APPROX = new RegExp('(?:\\bcca\\.?|\\baprox\\.?|\\bcirca|\\bca\\.|~)\\s*' + SIZE_NUM + '\\s*' + SIZE_UNIT + '\\b', 'i');
  var SIZE_ANY = new RegExp(SIZE_START + SIZE_NUM + '\\s*' + SIZE_UNIT + '\\b' + SIZE_NOT_NUTRIENT, 'gi');
  var SIZE_COUNT = new RegExp(
    SIZE_START +
      '(?:(\\d+)\\s*[x×]\\s*)?(\\d+)\\s*(?:buc(?:ati|ăți)?\\.?|role|rulouri|capsule|plicuri|pliculete|tablete|pastile|servetele|șervețele|perechi)(?![\\w])',
    'i'
  );
  var SIZE_PER_PIECE = /\bbucat[aă](?![a-z])/i;
  var SIZE_PACK = new RegExp(SIZE_START + '(\\d+)\\s*-?\\s*pack\\b', 'i');

  function sizeNumber(value) {
    return typeof value === 'number' ? value : Number(String(value).replace(',', '.'));
  }

  function formatSize(value, unit) {
    var amount = sizeNumber(value);
    var u = String(unit).toLowerCase();
    if (!isFinite(amount) || amount <= 0) return null;
    if (u === 'cl') {
      amount *= 10;
      u = 'ml';
    }
    if (u === 'l' && amount < 1) {
      amount *= 1000;
      u = 'ml';
    }
    if (u === 'kg' && amount < 1) {
      amount *= 1000;
      u = 'g';
    }
    if (u === 'g' && amount >= 1000) {
      amount /= 1000;
      u = 'kg';
    }
    if (u === 'ml' && amount >= 1000) {
      amount /= 1000;
      u = 'l';
    }
    var shown = String(Math.round(amount * 100) / 100).replace('.', ',');
    return shown + ' ' + (u === 'l' ? 'L' : u);
  }

  function lastSize(text) {
    var last = null;
    var match;
    SIZE_ANY.lastIndex = 0;
    while ((match = SIZE_ANY.exec(text))) last = match;
    return last ? formatSize(last[1], last[2]) : null;
  }

  function sizeFromMeasurement(raw) {
    var parts = String(raw || '').split('|');
    var value = Number(parts[0]);
    var unit = (parts[1] || '').toUpperCase();
    if (!value || !unit) return null;
    if (unit === 'ITEM') return value > 1 ? Math.round(value) + ' buc.' : null;
    if (['G', 'KG', 'ML', 'CL', 'L'].indexOf(unit) < 0) return null;
    return formatSize(value, unit);
  }

  function sizeFromTag(tag) {
    if (!tag || !/^gramaj\s*:/i.test(tag)) return null;
    var value = tag.slice(tag.indexOf(':') + 1).trim();
    var count = /^(\d+)\s*buc/i.exec(value);
    if (count) return Number(count[1]) > 1 ? count[1] + ' buc.' : null;
    return lastSize(value);
  }

  function packSize(title, measurement, tag) {
    var multi = SIZE_MULTI.exec(title);
    if (multi) {
      var one = formatSize(multi[2], multi[3]);
      if (one && Number(multi[1]) > 1) return multi[1] + ' × ' + one;
    }
    var count = SIZE_COUNT.exec(title);
    if (count) {
      var total = Number(count[2]) * (count[1] ? Number(count[1]) : 1);
      if (total > 1) return total + ' buc.';
    }
    var pack = SIZE_PACK.exec(title);
    if (pack && Number(pack[1]) > 1) {
      var single = lastSize(title);
      return single ? pack[1] + ' × ' + single : pack[1] + ' buc.';
    }
    var approx = SIZE_APPROX.exec(title);
    if (approx) {
      var around = formatSize(approx[1], approx[2]);
      if (around) return 'ca. ' + around;
    }
    var size = lastSize(title) || sizeFromMeasurement(measurement) || sizeFromTag(tag);
    if (size && SIZE_PER_PIECE.test(title) && /\s(g|kg)$/.test(size)) return 'ca. ' + size;
    return size;
  }
  window.GaPackSize = packSize;

  function cartSizes() {
    each(document.querySelectorAll('.cart-item__title[data-ga-masura]'), function (link) {
      var row = link.closest('.cart-item__product--info') || link.parentNode;
      if (!row || row.querySelector('.ga-marime')) return;
      var text = packSize((link.textContent || '').trim(), link.getAttribute('data-ga-masura'), link.getAttribute('data-ga-gramaj'));
      if (!text) return;
      var pill = document.createElement('span');
      pill.className = 'ga-marime';
      pill.textContent = text;
      var line = link.closest('.flex.items-center.justify-between') || link.parentNode;
      line.parentNode.insertBefore(pill, line.nextSibling);
    });
  }

  function watchCartSizes() {
    if (!document.querySelector('.cart-item__title[data-ga-masura]') && !document.querySelector('main-cart, cart-items')) return;
    cartSizes();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        cartSizes();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  ready(function () {
    try {
      watchCartSizes();
    } catch (error) {
      if (window.console) console.warn('[ga] gramaj', error);
    }
    try {
      productDesk();
    } catch (error) {
      if (window.console) console.warn('[ga] produs', error);
    }
    try {
      accountLinks();
      tabArrows();
    } catch (error) {
      if (window.console) console.warn('[ga] cont/pastile', error);
    }
    try {
      footerGate();
    } catch (error) {
      if (window.console) console.warn('[ga] footer', error);
    }
  });
})();

/*
 * A șasea rundă (04.10.2026), cerută de Zoli înainte de publicarea temei:
 * - Favoritele au fost aici o seară (lista contului, ca în aplicație); a șaptea rundă le-a scos de pe site cu totul
 *   (Zoli: „vreau să scoatem de pe web de tot favoritele”). Rămân în aplicație. GroPulse iese și el din magazin.
 * - Coșul, ca în aplicație: „Ai un cod de reducere?” (codul pus pe coșul Shopify, deci ajunge singur la plată) și
 *   „Factură pe firmă?” (CUI-ul pleacă la „Companie” în checkout, prin widgetul de livrare: „legat cu checkout-ul
 *   NEAPĂRAT”).
 * A opta rundă (04.10.2026), Zoli: „nu se mai aplică cum trebuie [codurile]”. Codul scris acum se pune ca la checkout:
 * cel care nu se poate aplica nu rămâne pe coș (cu motivul adevărat, nu al altui cod), cel care așteaptă minimul
 * comenzii rămâne și se aplică singur, iar între două reduceri care nu merg împreună rămâne cea mai mare, spus clar.
 * Iconițele sunt din aplicație (Material Design Icons, Apache 2.0).
 */
(function () {
  'use strict';

  var root = document.documentElement;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function svg(paths, extraClass) {
    return (
      '<svg' + (extraClass ? ' class="' + extraClass + '"' : '') +
      ' viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="' + paths + '"/></svg>'
    );
  }

  function esc(text) {
    return String(text == null ? '' : text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var I_TICKET = 'M14.81 8.02 15.98 9.19 9.19 15.98 8.02 14.81ZM3.98 3.98H20.02Q20.81 3.98 21.4 4.57Q21.98 5.16 21.98 6V9.98Q21.19 9.98 20.6 10.57Q20.02 11.16 20.02 12Q20.02 12.84 20.6 13.43Q21.19 14.02 21.98 14.02V18Q21.98 18.84 21.4 19.43Q20.81 20.02 20.02 20.02H3.98Q3.19 20.02 2.6 19.43Q2.02 18.84 2.02 18V14.02Q2.81 14.02 3.4 13.43Q3.98 12.84 3.98 12Q3.98 11.16 3.4 10.57Q2.81 9.98 2.02 9.98V6Q2.02 5.16 2.6 4.57Q3.19 3.98 3.98 3.98ZM3.98 6V8.53Q4.92 9.09 5.46 10.01Q6 10.92 6 12Q6 13.08 5.46 13.99Q4.92 14.91 3.98 15.47V18H20.02V15.47Q19.08 14.91 18.54 13.99Q18 13.08 18 12Q18 10.92 18.54 10.01Q19.08 9.09 20.02 8.53V6ZM9.52 8.02Q10.12 8.02 10.57 8.44Q11.02 8.86 11.02 9.49Q11.02 10.12 10.57 10.57Q10.12 11.02 9.49 11.02Q8.86 11.02 8.44 10.57Q8.02 10.12 8.02 9.49Q8.02 8.86 8.44 8.44Q8.86 8.02 9.52 8.02ZM14.48 12.98Q15.14 12.98 15.56 13.43Q15.98 13.88 15.98 14.51Q15.98 15.14 15.56 15.56Q15.14 15.98 14.51 15.98Q13.88 15.98 13.43 15.56Q12.98 15.14 12.98 14.51Q12.98 13.88 13.43 13.43Q13.88 12.98 14.48 12.98Z';
  var I_DOMAIN = 'M18 15H15.98V17.02H18ZM18 11.02H15.98V12.98H18ZM20.02 18.98H12V17.02H14.02V15H12V12.98H14.02V11.02H12V9H20.02ZM9.98 6.98H8.02V5.02H9.98ZM9.98 11.02H8.02V9H9.98ZM9.98 15H8.02V12.98H9.98ZM9.98 18.98H8.02V17.02H9.98ZM6 6.98H3.98V5.02H6ZM6 11.02H3.98V9H6ZM6 15H3.98V12.98H6ZM6 18.98H3.98V17.02H6ZM12 6.98V3H2.02V21H21.98V6.98Z';
  var I_PLUS = 'M18.98 12.98H12.98V18.98H11.02V12.98H5.02V11.02H11.02V5.02H12.98V11.02H18.98Z';
  var I_CHECK = 'M12 2.02Q9.28 2.02 6.98 3.35Q4.69 4.69 3.35 6.98Q2.02 9.28 2.02 12Q2.02 14.72 3.35 17.02Q4.69 19.31 6.98 20.65Q9.28 21.98 12 21.98Q14.72 21.98 17.02 20.65Q19.31 19.31 20.65 17.02Q21.98 14.72 21.98 12Q21.98 9.28 20.65 6.98Q19.31 4.69 17.02 3.35Q14.72 2.02 12 2.02ZM9.98 17.02 5.02 12 6.42 10.59 9.98 14.16 17.58 6.56 18.98 8.02Z';
  var I_ALERT = 'M11.02 15H12.98V17.02H11.02ZM11.02 6.98H12.98V12.98H11.02ZM12 2.02Q9.28 2.02 6.98 3.35Q4.69 4.69 3.35 6.98Q2.02 9.28 2.02 12Q2.02 13.97 2.77 15.82Q3.52 17.67 4.92 19.08Q6.33 20.48 8.18 21.23Q10.03 21.98 12 21.98Q13.97 21.98 15.82 21.23Q17.67 20.48 19.08 19.08Q20.48 17.67 21.23 15.82Q21.98 13.97 21.98 12Q21.98 10.03 21.23 8.18Q20.48 6.33 19.08 4.92Q17.67 3.52 15.82 2.77Q13.97 2.02 12 2.02ZM12 20.02Q9.84 20.02 7.99 18.94Q6.14 17.86 5.06 16.01Q3.98 14.16 3.98 12Q3.98 9.84 5.06 7.99Q6.14 6.14 7.99 5.06Q9.84 3.98 12 3.98Q14.16 3.98 16.01 5.06Q17.86 6.14 18.94 7.99Q20.02 9.84 20.02 12Q20.02 14.16 18.94 16.01Q17.86 17.86 16.01 18.94Q14.16 20.02 12 20.02Z';

  function readData() {
    try {
      return JSON.parse(document.getElementById('GaData').textContent) || {};
    } catch (error) {
      return {};
    }
  }
  var data = readData();
  // Clientul logat (din Liquid, snippets/grocera-bara-sus.liquid), ca text; `null` = oaspete.
  var CLIENT = data.client != null && data.client !== '' ? String(data.client) : null;

  var noticeTimer = null;
  /*
   * Codurile de eroare (08.10.2026, Zoli: „pt ei să fie simplu și să fie pt noi doar niște numere”): „mesaj (Cod
   * 5001-58319)”, iar cazul pleacă în jurnalul nostru (`grocera-erori.js`, din embed-ul „Grocera · livrare”). Fără el
   * (embed oprit, script vechi în cache), rămâne doar mesajul, ca înainte.
   */
  function withErrorCode(key, text, details, error) {
    var E = window.GroceraErori;
    if (!E || typeof E.raporteaza !== 'function') return text;
    try {
      return E.text(E.raporteaza(key, { mesaj: text, detalii: details || null, eroare: error || null }));
    } catch (x) {
      return text;
    }
  }

  /** Cât stă anunțul. Unul cu cod de eroare stă mai mult: omul trebuie să apuce să-l pozeze. */
  function notice(text, ms) {
    var box = document.querySelector('.ga-anunt');
    if (!box) {
      box = document.createElement('div');
      box.className = 'ga-anunt';
      box.setAttribute('role', 'status');
      box.setAttribute('aria-live', 'polite');
      document.body.appendChild(box);
    }
    box.textContent = text;
    requestAnimationFrame(function () {
      box.classList.add('is-on');
    });
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(function () {
      box.classList.remove('is-on');
    }, ms || 2400);
  }

  /* ───────── Coșul: „Ai un cod de reducere?” și „Factură pe firmă?” ───────── */

  var CUI_KEY = 'grocera.factura.cui';

  function normCui(text) {
    var c = String(text == null ? '' : text).toUpperCase().replace(/[\s.\-/]/g, '');
    return c.indexOf('RO') === 0 ? 'RO' + c.slice(2) : c;
  }

  // Ca în aplicație (invoice-utils.ts): 2–10 cifre, ultima e cifra de control (cheia 753217532), cu sau fără RO.
  function validCui(text) {
    var digits = normCui(text).replace(/^RO/, '');
    if (!/^\d{2,10}$/.test(digits)) return false;
    var control = Number(digits.charAt(digits.length - 1));
    var body = digits.slice(0, -1);
    while (body.length < 9) body = '0' + body;
    var key = '753217532';
    var sum = 0;
    for (var i = 0; i < 9; i++) sum += Number(body.charAt(i)) * Number(key.charAt(i));
    var rest = (sum * 10) % 11;
    if (rest === 10) rest = 0;
    return rest === control;
  }

  /*
   * CUI-ul stă pe browser pentru comenzile următoare, ca în aplicație, ținut minte cu contul care l-a scris: alt cont
   * (sau ieșit din cont) pornește fără el. Widgetul de livrare (grocera-routes, grocera-livrare.js) îl citește din
   * aceeași cheie și îl trimite checkout-ului la „Companie”.
   */
  function readCui() {
    try {
      var s = JSON.parse(localStorage.getItem(CUI_KEY) || 'null');
      if (!s || !s.cui) return null;
      if (s.cont && s.cont !== CLIENT) {
        localStorage.removeItem(CUI_KEY);
        return null;
      }
      return validCui(s.cui) ? normCui(s.cui) : null;
    } catch (error) {
      return null;
    }
  }

  function writeCui(cui) {
    try {
      if (cui) localStorage.setItem(CUI_KEY, JSON.stringify({ cui: cui, cont: CLIENT }));
      else localStorage.removeItem(CUI_KEY);
    } catch (error) {}
    // Widgetul trimite pe loc preferința nouă (adresa + CUI-ul) pentru coșul ăsta.
    document.dispatchEvent(new CustomEvent('grocera:firma', { detail: { cui: cui || null } }));
  }

  function normCode(text) {
    return String(text == null ? '' : text).replace(/\s+/g, '').toUpperCase();
  }

  function money(bani) {
    return (Math.round(bani) / 100).toFixed(2).replace('.', ',') + ' RON';
  }

  // Cât scade codul, cum l-a socotit Shopify pe coș: pe rânduri și pe toată comanda.
  function codeAmount(cart, code) {
    var sum = 0;
    each((cart && cart.items) || [], function (item) {
      each(item.line_level_discount_allocations || [], function (allocation) {
        var app = allocation.discount_application || {};
        if (app.type === 'discount_code' && normCode(app.title) === code) sum += Number(allocation.amount) || 0;
      });
    });
    each((cart && cart.cart_level_discount_applications) || [], function (app) {
      if (app.type === 'discount_code' && normCode(app.title) === code) sum += Number(app.total_allocated_amount) || 0;
    });
    return sum;
  }

  function cartCodes(cart) {
    return ((cart && cart.discount_codes) || []).map(function (d) {
      return { code: normCode(d.code), applicable: !!d.applicable };
    });
  }

  function readCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    });
  }

  // Secțiunile coșului (pagina și sertarul), ca tema să le redeseneze cu reducerea nouă (cart.js din temă).
  function cartSections() {
    var list = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: list } }));
    return list.filter(function (id, i) {
      return id && list.indexOf(id) === i;
    });
  }

  function refreshCart() {
    var ids = cartSections();
    var sections = ids.length
      ? fetch('/cart?sections=' + encodeURIComponent(ids.join(',')), { credentials: 'same-origin' })
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .catch(function () {
            return null;
          })
      : Promise.resolve(null);
    return Promise.all([readCart(), sections]).then(function (both) {
      var cart = both[0];
      var html = both[1];
      // Doar cu toate secțiunile primite: tema scoate din pagină coșul pe care nu-l găsește în răspuns.
      var whole = !!html && ids.every(function (id) {
        var part = html[id];
        if (typeof part !== 'string' || !part) return false;
        return id.indexOf('main-cart') < 0 || part.indexOf('id="MainCart-') >= 0;
      });
      if (whole && window.FoxTheme && FoxTheme.pubsub) {
        cart.sections = html;
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
      }
      return cart;
    });
  }

  /*
   * Codurile se pun pe coș prin Storefront API-ul magazinului, chemat direct din pagină: pentru coș, Shopify îl lasă
   * fără token. Doar el spune DE CE nu se aplică un cod (`warnings`); `/cart.js` spune doar că nu se aplică. Pus pe
   * coș, codul ajunge singur în checkout. (Până în a opta rundă treceau prin grocera-routes, `/apps/urmarire/reducere`:
   * același API, cu un drum în plus.)
   */
  var SF_URL = '/api/2026-10/graphql.json';
  var SF_CODES =
    'mutation CoduriReducere($cartId: ID!, $coduri: [String!]!) @inContext(language: RO) {' +
    ' cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $coduri) {' +
    ' cart { discountCodes { code applicable } } warnings { code message } userErrors { message } } }';

  function uniqueCodes(list) {
    var out = [];
    each(list, function (text) {
      var code = normCode(text);
      if (code && out.indexOf(code) < 0) out.push(code);
    });
    return out;
  }

  function postJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    });
  }

  /**
   * Pune pe coș exact lista dată (Shopify o înlocuiește pe toată) și întoarce codurile, cu „se aplică” sau nu, plus
   * avertismentele Shopify. Fără Storefront (rețea, API schimbat), lista ajunge tot pe coș, prin coșul temei
   * (`/cart/update.js`, „discount”), doar fără motive (`known: false`).
   */
  function setCodes(token, codes) {
    var list = uniqueCodes(codes);
    return postJson(SF_URL, { query: SF_CODES, variables: { cartId: 'gid://shopify/Cart/' + token, coduri: list } })
      .then(function (body) {
        var r = body && body.data && body.data.cartDiscountCodesUpdate;
        if (!r || !r.cart || (r.userErrors && r.userErrors.length)) throw new Error('storefront');
        return {
          codes: (r.cart.discountCodes || []).map(function (d) {
            return { code: normCode(d.code), applicable: !!d.applicable };
          }),
          warnings: r.warnings || [],
          known: true,
        };
      })
      .catch(function () {
        return postJson('/cart/update.js', { discount: list.join(',') }).then(function (cart) {
          return { codes: cartCodes(cart), warnings: [], known: false };
        });
      });
  }

  // Codul scris întreg în mesajul Shopify („COD15”, nu bucată din „COD150”).
  function mentions(message, code) {
    var text = String(message == null ? '' : message).toUpperCase();
    for (var at = text.indexOf(code); at >= 0; at = text.indexOf(code, at + 1)) {
      if (!/[A-Z0-9_-]/.test(text.charAt(at - 1)) && !/[A-Z0-9_-]/.test(text.charAt(at + code.length))) return true;
    }
    return false;
  }

  /**
   * De ce nu se aplică fiecare cod. Avertismentele Shopify au ca țintă coșul, nu codul: codul e scris în mesaj
   * („Codul de reducere COD15 nu este acceptat”), mai puțin la cele fără nume (DISCOUNT_NOT_FOUND: „Introduceți un cod
   * de reducere valid”, DISCOUNT_CURRENTLY_INACTIVE: „Acest discount nu mai este valid”), care le rămân codurilor fără
   * alt motiv. Ordinea avertismentelor nu e a codurilor: când nu se poate ști care e care, două coduri moarte primesc
   * „NEVALID” (nu există sau nu mai e activ). Până acum se lua primul avertisment, al oricărui cod: un cod bun putea fi
   * scos ca „inexistent” din cauza altuia, iar unul inexistent primea motivul altuia.
   */
  function codeReasons(codes, warnings) {
    var reasons = {};
    var open = [];
    var all = [];
    each(codes, function (d) {
      all.push(d.code);
      if (!d.applicable) open.push(d.code);
    });
    var unnamed = [];
    each(warnings || [], function (w) {
      var kind = String((w && w.code) || '');
      if (kind.indexOf('DISCOUNT_') !== 0) return;
      var named = all.filter(function (code) {
        return mentions(w && w.message, code);
      });
      if (!named.length) {
        unnamed.push(kind);
        return;
      }
      each(named, function (code) {
        if (open.indexOf(code) >= 0 && !reasons[code]) reasons[code] = kind;
      });
    });
    var rest = open.filter(function (code) {
      return !reasons[code];
    });
    if (rest.length && unnamed.length) {
      var same = unnamed.every(function (kind) {
        return kind === unnamed[0];
      });
      var allDead = unnamed.every(function (kind) {
        return !!DEAD[kind];
      });
      var guess = same && (rest.length === 1 || unnamed.length === rest.length) ? unnamed[0] : allDead && unnamed.length >= rest.length ? 'NEVALID' : null;
      if (guess) {
        each(rest, function (code) {
          reasons[code] = guess;
        });
      }
    }
    return reasons;
  }

  // Se pot aplica mai târziu pe același coș (minimul comenzii, alte produse, contul): rămân pe coș, cu motivul.
  var PENDING = {
    DISCOUNT_PURCHASE_NOT_IN_RANGE: 'Comanda e încă sub minimul codului',
    DISCOUNT_QUANTITY_NOT_IN_RANGE: 'Cere mai multe produse în coș',
    DISCOUNT_NO_ENTITLED_LINE_ITEMS: 'Doar pentru produse pe care nu le ai în coș',
    DISCOUNT_NO_ENTITLED_SHIPPING_LINES: 'E la livrare: se vede la plată',
    DISCOUNT_ELIGIBLE_CUSTOMER_MISSING: 'Intră în cont ca să se aplice',
  };
  // Nu se vor aplica pe coșul ăsta: ies de pe coș (checkout-ul le lasă oricum deoparte, fără o vorbă).
  var DEAD = {
    DISCOUNT_NOT_FOUND: 'Nu există',
    DISCOUNT_CURRENTLY_INACTIVE: 'Nu mai e activ',
    DISCOUNT_USAGE_LIMIT_REACHED: 'S-a folosit de câte ori se putea',
    DISCOUNT_CUSTOMER_USAGE_LIMIT_REACHED: 'L-ai folosit deja',
    DISCOUNT_CUSTOMER_NOT_ELIGIBLE: 'Nu e valabil pentru contul tău',
    DISCOUNT_INCOMPATIBLE_PURCHASE_TYPE: 'Nu se aplică acestui tip de comandă',
    NEVALID: 'Nu e valabil',
  };
  // Nu se cumulează cu o reducere mai mare de pe coș (Shopify o păstrează pe cea mai mare).
  var LOST = 'DISCOUNT_CODE_NOT_HONOURED';

  // Reducerile de pe coș acum, pe nume, cu suma: codurile și cele automate (ex. 20PTBAIETI), cea mai mare întâi.
  function cartDiscounts(cart) {
    var byKey = {};
    var list = [];
    function add(app, amount) {
      if (!app || !(amount > 0)) return;
      var isCode = app.type === 'discount_code';
      var name = isCode ? normCode(app.title) : String(app.title || 'Reducere').trim();
      var key = (isCode ? 'cod:' : 'auto:') + name;
      if (!byKey[key]) {
        byKey[key] = { name: name, code: isCode, amount: 0 };
        list.push(byKey[key]);
      }
      byKey[key].amount += amount;
    }
    each((cart && cart.items) || [], function (item) {
      each(item.line_level_discount_allocations || [], function (allocation) {
        add(allocation.discount_application, Number(allocation.amount) || 0);
      });
    });
    each((cart && cart.cart_level_discount_applications) || [], function (app) {
      add(app, Number(app.total_allocated_amount) || 0);
    });
    return list.sort(function (a, b) {
      return b.amount - a.amount;
    });
  }

  function joinRo(items) {
    return items.length < 2 ? items.join('') : items.slice(0, -1).join(', ') + ' și ' + items[items.length - 1];
  }

  // Codul scos de pe coș fără să-l fi cerut omul (nu mai e valabil), într-o propoziție.
  function deadSentence(code, why) {
    if (why === 'DISCOUNT_CUSTOMER_USAGE_LIMIT_REACHED') return 'Ai folosit deja codul ' + code + ', așa că l-am scos din coș.';
    var reason = {
      DISCOUNT_NOT_FOUND: 'nu există',
      DISCOUNT_CURRENTLY_INACTIVE: 'nu mai e activ',
      DISCOUNT_USAGE_LIMIT_REACHED: 's-a folosit deja de câte ori se putea',
      DISCOUNT_CUSTOMER_NOT_ELIGIBLE: 'nu e valabil pentru contul tău',
      DISCOUNT_INCOMPATIBLE_PURCHASE_TYPE: 'nu se aplică acestui tip de comandă',
    }[why] || 'nu mai e valabil';
    return 'Codul ' + code + ' ' + reason + ', așa că l-am scos din coș.';
  }

  /**
   * Ce-i spunem omului după „Aplică”. `kind`: `ok`, un cod de avertisment Shopify, `NECUNOSCUT` (Shopify n-a spus de
   * ce) sau `FARA_MOTIV` (pus prin `/cart/update.js`, fără Storefront). `lost`: codurile care se aplicau și au ieșit
   * în fața celui nou (nu se cumulează); `gone`: codurile moarte scoase odată cu el.
   */
  function codeMessage(code, kind, cart, lost, gone, client) {
    var text;
    if (kind === 'ok') {
      var amount = codeAmount(cart, code);
      text = amount > 0 ? 'Am aplicat codul ' + code + ': −' + money(amount) + '.' : 'Codul ' + code + ' e valabil. Reducerea se vede la plată.';
      if (lost.length === 1) text += ' Codul ' + lost[0] + ' nu se cumulează cu el și reducea mai puțin, așa că l-am scos.';
      if (lost.length > 1) text += ' Codurile ' + joinRo(lost) + ' nu se cumulează cu el și reduceau mai puțin, așa că le-am scos.';
    } else if (kind === LOST) {
      var others = cartDiscounts(cart)
        .filter(function (d) {
          return !(d.code && d.name === code);
        })
        .slice(0, 2)
        .map(function (d) {
          return (d.code ? 'codul ' : 'reducerea ') + d.name + ' (−' + money(d.amount) + ')';
        });
      text =
        'Codul ' + code + ' nu se cumulează cu ' +
        (others.length ? joinRo(others) + (others.length > 1 ? ', care sunt mai mari.' : ', care e mai mare.') : 'reducerile pe care le ai deja în coș, care sunt mai mari.') +
        ' Când două reduceri nu merg împreună, rămâne cea mai mare.';
    } else if (kind === 'DISCOUNT_NOT_FOUND') {
      text = client
        ? 'Codul ' + code + ' nu există. Verifică dacă e scris corect. Reducerile automate nu au cod: apar singure în coș.'
        : 'Codul ' + code + ' nu există. Verifică dacă e scris corect. Reducerile automate nu au cod: apar singure în coș, iar cele doar pentru tine, după ce intri în cont.';
    } else if (kind === 'DISCOUNT_CURRENTLY_INACTIVE') {
      text = 'Codul ' + code + ' nu mai e activ: a expirat sau încă n-a început.';
    } else if (kind === 'NEVALID') {
      text = 'Codul ' + code + ' nu există sau nu mai e activ. Verifică dacă e scris corect.';
    } else if (kind === 'DISCOUNT_USAGE_LIMIT_REACHED') {
      text = 'Codul ' + code + ' nu mai poate fi folosit: s-a folosit deja de câte ori se putea.';
    } else if (kind === 'DISCOUNT_CUSTOMER_USAGE_LIMIT_REACHED') {
      text = 'Ai folosit deja codul ' + code + '. Se poate folosi o singură dată de fiecare client.';
    } else if (kind === 'DISCOUNT_CUSTOMER_NOT_ELIGIBLE') {
      text = 'Codul ' + code + ' nu e valabil pentru contul tău.';
    } else if (kind === 'DISCOUNT_INCOMPATIBLE_PURCHASE_TYPE') {
      text = 'Codul ' + code + ' nu se aplică acestui tip de comandă.';
    } else if (kind === 'DISCOUNT_PURCHASE_NOT_IN_RANGE') {
      text = 'Am pus codul ' + code + ' pe coș, dar comanda e încă sub minimul lui (la produsele eligibile). Se aplică singur când ajungi la minim.';
    } else if (kind === 'DISCOUNT_QUANTITY_NOT_IN_RANGE') {
      text = 'Am pus codul ' + code + ' pe coș. Se aplică singur când ai destule produse în coș.';
    } else if (kind === 'DISCOUNT_NO_ENTITLED_LINE_ITEMS') {
      text = 'Am pus codul ' + code + ' pe coș, dar e doar pentru anumite produse, pe care nu le ai în coș. Se aplică singur când le adaugi.';
    } else if (kind === 'DISCOUNT_NO_ENTITLED_SHIPPING_LINES') {
      text = 'Am pus codul ' + code + ' pe coș. E o reducere la livrare: se vede la plată.';
    } else if (kind === 'DISCOUNT_ELIGIBLE_CUSTOMER_MISSING') {
      text = 'Am pus codul ' + code + ' pe coș. E doar pentru anumiți clienți: intră în cont și se aplică singur.';
    } else if (kind === 'FARA_MOTIV') {
      text = 'Codul ' + code + ' nu se aplică acestui coș sau nu mai e activ.';
    } else {
      text = 'Codul ' + code + ' nu se aplică acestui coș.';
    }
    if (gone.length === 1) text += ' Am scos și codul ' + gone[0] + ', care nu mai e valabil.';
    if (gone.length > 1) text += ' Am scos și codurile ' + joinRo(gone) + ', care nu mai sunt valabile.';
    return text;
  }

  function cartExtras() {
    var mainCart = document.querySelector('main-cart');
    if (!mainCart) return;

    var state = {
      cart: null,
      codeOpen: false,
      codeDraft: '',
      codeBusy: false,
      codeMsg: null,
      // De ce nu se aplică (încă) fiecare cod de pe coș, după avertismentele Shopify (`codeReasons`).
      reasons: {},
      cui: readCui(),
      cuiOpen: false,
      cuiDraft: '',
      cuiError: '',
    };

    var box = document.createElement('div');
    box.className = 'ga-cos-extra';

    function head(icon, active, title, subtitle, action) {
      return (
        '<div class="ga-cos-card__cap">' +
        '<span class="ga-cos-card__ic' + (active ? ' is-on' : '') + '">' + svg(icon) + '</span>' +
        '<span class="ga-cos-card__texte"><span class="ga-cos-card__titlu">' + esc(title) + '</span>' +
        (subtitle ? '<span class="ga-cos-card__sub">' + subtitle + '</span>' : '') + '</span>' +
        (action || '') +
        '</div>'
      );
    }

    function codeCard() {
      var codes = cartCodes(state.cart);
      var title = codes.length || state.codeOpen ? 'Cod de reducere' : 'Ai un cod de reducere?';
      var sub = !codes.length && !state.codeOpen ? 'Îl aplicăm acum și vezi reducerea în coș' : '';
      var action = state.codeOpen
        ? ''
        : '<button type="button" class="ga-cos-card__link" data-ga-cod-deschide>' + svg(I_PLUS) + (codes.length ? 'Alt cod' : 'Adaugă') + '</button>';
      var html = '<div class="ga-cos-card' + (!codes.length && !state.codeOpen ? ' ga-cos-card--apasabil' : '') + '" data-ga-cod>' + head(I_TICKET, codes.length > 0, title, sub, action);
      codes.forEach(function (d) {
        var amount = codeAmount(state.cart, d.code);
        var why = state.reasons[d.code];
        var status = d.applicable
          ? amount > 0
            ? '−' + money(amount)
            : 'Valabil; reducerea se vede la plată'
          : PENDING[why] || DEAD[why] || (why === LOST ? 'Nu se cumulează cu o reducere mai mare' : 'Nu se aplică acum');
        html +=
          '<div class="ga-cos-card__rand">' +
          '<span class="ga-cos-card__stare-ic' + (d.applicable ? ' is-ok' : '') + '">' + svg(d.applicable ? I_CHECK : I_ALERT) + '</span>' +
          '<span class="ga-cos-card__texte"><span class="ga-cos-card__cod">' + esc(d.code) + '</span>' +
          '<span class="ga-cos-card__stare' + (d.applicable && amount > 0 ? ' is-ok' : '') + '">' + esc(status) + '</span></span>' +
          '<button type="button" class="ga-cos-card__scoate" data-ga-cod-scoate="' + esc(d.code) + '" aria-label="Scoate codul ' + esc(d.code) + '">Scoate</button>' +
          '</div>';
      });
      if (state.codeOpen) {
        html +=
          '<form class="ga-cos-card__form" data-ga-cod-form novalidate>' +
          '<input class="ga-cos-card__camp' + (state.codeMsg && !state.codeMsg.ok && !state.codeMsg.info ? ' is-err' : '') + '" name="cod" type="text" ' +
          'placeholder="Scrie codul" aria-label="Codul de reducere" autocapitalize="characters" autocomplete="off" ' +
          'autocorrect="off" spellcheck="false" maxlength="40" enterkeyhint="done" value="' + esc(state.codeDraft) + '">' +
          '<div class="ga-cos-card__butoane">' +
          '<button type="button" class="ga-cos-buton ga-cos-buton--alb" data-ga-cod-anuleaza>Anulează</button>' +
          '<button type="submit" class="ga-cos-buton"' + (state.codeBusy ? ' disabled aria-busy="true"' : '') + '>' + (state.codeBusy ? 'Se aplică…' : 'Aplică') + '</button>' +
          '</div></form>';
      }
      if (state.codeMsg) {
        var tone = state.codeMsg.ok ? 'is-ok' : state.codeMsg.info ? 'is-info' : 'is-err';
        html += '<p class="ga-cos-card__mesaj ' + tone + '" role="status">' + esc(state.codeMsg.text) + '</p>';
      }
      return html + '</div>';
    }

    function cuiCard() {
      if (state.cuiOpen) {
        return (
          '<div class="ga-cos-card" data-ga-firma>' +
          head(I_DOMAIN, true, 'Factură pe firmă', 'Codul fiscal (CUI), cu sau fără RO. Numele și adresa firmei apar pe factură după CUI.') +
          '<form class="ga-cos-card__form" data-ga-firma-form novalidate>' +
          '<label class="ga-cos-card__eticheta" for="GaCui">CUI-ul firmei</label>' +
          '<input id="GaCui" class="ga-cos-card__camp' + (state.cuiError ? ' is-err' : '') + '" name="cui" type="text" ' +
          'placeholder="ex.: RO12345678" autocapitalize="characters" autocomplete="off" autocorrect="off" spellcheck="false" ' +
          'maxlength="16" enterkeyhint="done" value="' + esc(state.cuiDraft) + '">' +
          (state.cuiError ? '<p class="ga-cos-card__mesaj is-err" role="alert">' + esc(state.cuiError) + '</p>' : '') +
          '<div class="ga-cos-card__butoane">' +
          '<button type="button" class="ga-cos-buton ga-cos-buton--alb" data-ga-firma-anuleaza>Anulează</button>' +
          '<button type="submit" class="ga-cos-buton">Salvează</button>' +
          '</div>' +
          (state.cui ? '<button type="button" class="ga-cos-card__renunta" data-ga-firma-sterge>Nu mai vreau factură pe firmă</button>' : '') +
          '</form></div>'
        );
      }
      if (state.cui) {
        return (
          '<div class="ga-cos-card" data-ga-firma>' +
          head(I_DOMAIN, true, 'Factură pe firmă', '<span class="ga-cos-card__valoare">CUI ' + esc(state.cui) + '</span>',
            '<button type="button" class="ga-cos-card__link" data-ga-firma-deschide aria-label="Schimbă CUI-ul">Schimbă</button>') +
          '<p class="ga-cos-card__nota">Îl trecem noi la plată, la „Companie”. Rămâne și pentru comenzile următoare.</p>' +
          '</div>'
        );
      }
      return (
        '<div class="ga-cos-card ga-cos-card--apasabil" data-ga-firma>' +
        head(I_DOMAIN, false, 'Factură pe firmă?', 'Adaugă CUI-ul firmei',
          '<button type="button" class="ga-cos-card__link" data-ga-firma-deschide aria-label="Factură pe firmă? Adaugă CUI-ul firmei">' + svg(I_PLUS) + 'Adaugă</button>') +
        '</div>'
      );
    }

    function render(focus) {
      box.innerHTML = codeCard() + cuiCard();
      if (focus) {
        var field = box.querySelector(focus);
        if (field) {
          field.focus();
          var end = field.value.length;
          try {
            field.setSelectionRange(end, end);
          } catch (error) {}
        }
      }
    }

    // Lângă widgetul de livrare („Unde livrăm?”), ca în aplicație: întâi livrarea, apoi codul și factura.
    function mount() {
      var widget = mainCart.querySelector('.gr-liv-widget');
      if (widget && widget.parentNode) {
        if (widget.nextSibling !== box) widget.parentNode.insertBefore(box, widget.nextSibling);
        return;
      }
      var buttons = mainCart.querySelector('.cart__footer--buttons');
      if (!buttons) return;
      var checkout = buttons.querySelector('[name="checkout"]');
      if (box.parentNode !== buttons) buttons.insertBefore(box, checkout || null);
    }

    /**
     * Codul scris, ca la checkout: se pune pe coș lângă cele de acolo, apoi Shopify spune ce se aplică.
     * - se aplică: rămâne; codurile care se aplicau și nu se cumulează cu el ies (au pierdut în fața lui, deci reduceau
     *   mai puțin);
     * - așteaptă (minimul comenzii, alte produse, contul): rămâne și se aplică singur când e cazul;
     * - nu se poate aplica (nu există, a expirat, folosit deja) sau e mai mic decât o reducere cu care nu se cumulează
     *   (ex. 20% automat pe aceleași produse): iese de pe coș, cu motivul adevărat.
     * Codurile moarte rămase pe coș (din linkuri vechi) ies odată cu el.
     */
    function applyCode(raw) {
      var code = normCode(raw);
      if (!code) {
        state.codeMsg = { ok: false, text: 'Scrie codul de reducere.' };
        render('[data-ga-cod-form] input');
        return;
      }
      state.codeBusy = true;
      state.codeMsg = null;
      render();
      var token = null;
      var kind = null;
      var lost = [];
      var gone = [];
      readCart()
        .then(function (cart) {
          token = cart.token;
          var before = cartCodes(cart);
          var wasOn = {};
          each(before, function (d) {
            if (d.applicable) wasOn[d.code] = true;
          });
          return setCodes(token, before.map(function (d) {
            return d.code;
          }).concat(code)).then(function (r) {
            var reasons = r.known ? codeReasons(r.codes, r.warnings) : {};
            var mine = r.codes.filter(function (d) {
              return d.code === code;
            })[0];
            if (mine && mine.applicable) kind = 'ok';
            else if (!mine) kind = r.known ? 'DISCOUNT_NOT_FOUND' : 'FARA_MOTIV';
            else kind = reasons[code] || (r.known ? 'NECUNOSCUT' : 'FARA_MOTIV');
            var keep = [];
            each(r.codes, function (d) {
              var why = reasons[d.code];
              if (d.code === code) {
                if (kind === 'ok' || PENDING[kind]) keep.push(d.code);
              } else if (d.applicable) {
                keep.push(d.code);
              } else if (DEAD[why]) {
                gone.push(d.code);
              } else if (why === LOST && kind === 'ok' && wasOn[d.code]) {
                lost.push(d.code);
              } else {
                keep.push(d.code);
              }
            });
            each(keep, function (c) {
              if (reasons[c]) state.reasons[c] = reasons[c];
              else delete state.reasons[c];
            });
            if (keep.length === r.codes.length) return null;
            return setCodes(token, keep);
          });
        })
        .then(function () {
          return refreshCart();
        })
        .then(function (cart) {
          state.cart = cart;
          // Pus sau în așteptare: gata. Mai mic decât reducerea de acum: nimic de corectat, doar de știut. Altfel (scris
          // greșit, expirat), câmpul rămâne deschis, cu codul în el.
          var done = kind === 'ok' || !!PENDING[kind] || kind === LOST;
          state.codeMsg = {
            ok: kind === 'ok',
            info: done && kind !== 'ok',
            text: codeMessage(code, kind, cart, lost, gone, CLIENT),
          };
          if (done) {
            state.codeOpen = false;
            state.codeDraft = '';
          }
        })
        .catch(function (error) {
          state.codeMsg = {
            ok: false,
            text: withErrorCode('reducere.verificare', 'Nu am putut verifica codul. Încearcă din nou.', { cod: code }, error),
          };
        })
        .then(function () {
          state.codeBusy = false;
          render(state.codeOpen ? '[data-ga-cod-form] input' : null);
        });
    }

    function removeCode(code) {
      state.codeMsg = null;
      readCart()
        .then(function (cart) {
          var rest = cartCodes(cart)
            .map(function (d) {
              return d.code;
            })
            .filter(function (c) {
              return c !== code;
            });
          return setCodes(cart.token, rest);
        })
        .then(function (r) {
          delete state.reasons[code];
          // Fără el, altul poate trece în față (cel care nu se cumula cu el): motivele de acum.
          if (r.known) {
            var reasons = codeReasons(r.codes, r.warnings);
            each(r.codes, function (d) {
              if (reasons[d.code]) state.reasons[d.code] = reasons[d.code];
              else delete state.reasons[d.code];
            });
          }
          return refreshCart();
        })
        .then(function (cart) {
          state.cart = cart;
          render();
        })
        .catch(function (error) {
          notice(withErrorCode('reducere.scoatere', 'Nu am putut scoate codul. Încearcă din nou.', { cod: code }, error), 6000);
        });
    }

    /*
     * Codurile ajunse pe coș altfel (linkuri `grocera.ro/discount/COD`, recomandări, afiliați) sau cele care nu se mai
     * aplică după o schimbare de coș: aflăm de la Shopify de ce (aceeași listă, trimisă din nou), iar cele care nu se vor
     * mai aplica deloc ies din coș, cu o vorbă. O singură dată pentru aceeași stare a coșului.
     */
    var reasonsKey = '';
    var reasonsBusy = false;
    var reasonsTimer = null;
    function ensureReasons() {
      clearTimeout(reasonsTimer);
      reasonsTimer = setTimeout(function () {
        var cart = state.cart;
        if (!cart || !cart.token || reasonsBusy || state.codeBusy) return;
        var codes = cartCodes(cart);
        each(codes, function (d) {
          if (d.applicable) delete state.reasons[d.code];
        });
        var missing = codes.some(function (d) {
          return !d.applicable && !state.reasons[d.code];
        });
        if (!missing) return;
        var key = cart.token + '|' + codes.map(function (d) {
          return d.code + (d.applicable ? '+' : '-');
        }).join(',');
        if (key === reasonsKey) return;
        reasonsKey = key;
        reasonsBusy = true;
        var gone = [];
        setCodes(cart.token, codes.map(function (d) {
          return d.code;
        }))
          .then(function (r) {
            if (!r.known) return null;
            var reasons = codeReasons(r.codes, r.warnings);
            var keep = [];
            each(r.codes, function (d) {
              var why = reasons[d.code];
              if (!d.applicable && DEAD[why]) {
                gone.push({ code: d.code, why: why });
                return;
              }
              keep.push(d.code);
              if (why) state.reasons[d.code] = why;
            });
            if (!gone.length) return null;
            return setCodes(cart.token, keep)
              .then(refreshCart)
              .then(function (fresh) {
                state.cart = fresh;
                if (state.codeBusy) return;
                state.codeMsg = {
                  ok: false,
                  info: true,
                  text:
                    gone.length === 1
                      ? deadSentence(gone[0].code, gone[0].why)
                      : 'Codurile ' + joinRo(gone.map(function (g) {
                          return g.code;
                        })) + ' nu mai sunt valabile, așa că le-am scos din coș.',
                };
              });
          })
          .catch(function () {})
          .then(function () {
            reasonsBusy = false;
            if (!box.contains(document.activeElement)) render();
          });
      }, 300);
    }

    function saveCui(raw) {
      var value = normCui(raw);
      if (!value) {
        state.cuiError = 'Scrie CUI-ul firmei.';
        render('#GaCui');
        return;
      }
      if (!validCui(value)) {
        state.cuiError = 'CUI-ul nu pare corect. Verifică cifrele (ex.: RO12345678).';
        state.cuiDraft = raw;
        render('#GaCui');
        return;
      }
      state.cui = value;
      state.cuiOpen = false;
      state.cuiError = '';
      writeCui(value);
      render();
    }

    box.addEventListener('click', function (event) {
      var t = event.target;
      if (t.closest('[data-ga-cod-deschide]') || (t.closest('[data-ga-cod].ga-cos-card--apasabil') && !t.closest('button, a, input'))) {
        state.codeOpen = true;
        state.codeMsg = null;
        render('[data-ga-cod-form] input');
        return;
      }
      if (t.closest('[data-ga-cod-anuleaza]')) {
        state.codeOpen = false;
        state.codeDraft = '';
        state.codeMsg = null;
        render();
        return;
      }
      var remove = t.closest('[data-ga-cod-scoate]');
      if (remove) {
        removeCode(remove.getAttribute('data-ga-cod-scoate'));
        return;
      }
      if (t.closest('[data-ga-firma-deschide]') || (t.closest('[data-ga-firma].ga-cos-card--apasabil') && !t.closest('button, a, input'))) {
        state.cuiOpen = true;
        state.cuiDraft = state.cui || '';
        state.cuiError = '';
        render('#GaCui');
        return;
      }
      if (t.closest('[data-ga-firma-anuleaza]')) {
        state.cuiOpen = false;
        state.cuiError = '';
        render();
        return;
      }
      if (t.closest('[data-ga-firma-sterge]')) {
        state.cui = null;
        state.cuiOpen = false;
        state.cuiError = '';
        writeCui(null);
        render();
      }
    });

    box.addEventListener('input', function (event) {
      if (event.target.name === 'cod') {
        state.codeDraft = event.target.value;
        if (state.codeMsg) {
          state.codeMsg = null;
          var msg = box.querySelector('[data-ga-cod] .ga-cos-card__mesaj');
          if (msg) msg.remove();
          event.target.classList.remove('is-err');
        }
      }
      if (event.target.name === 'cui') {
        state.cuiDraft = event.target.value;
        if (state.cuiError) {
          state.cuiError = '';
          var err = box.querySelector('[data-ga-firma] .ga-cos-card__mesaj');
          if (err) err.remove();
          event.target.classList.remove('is-err');
        }
      }
    });

    box.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.target.matches('[data-ga-cod-form]')) {
        if (!state.codeBusy) applyCode(event.target.elements.cod.value);
      } else if (event.target.matches('[data-ga-firma-form]')) {
        saveCui(event.target.elements.cui.value);
      }
    });

    // Coșul schimbat (cantități, produse): codurile se reverifică, cu sumele de acum.
    var refreshTimer = null;
    function softRefresh() {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(function () {
        readCart()
          .then(function (cart) {
            state.cart = cart;
            if (!box.contains(document.activeElement)) render();
            ensureReasons();
          })
          .catch(function () {});
      }, 250);
    }
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cart && event.cart.discount_codes && event.cart.items) {
          state.cart = event.cart;
          if (!box.contains(document.activeElement)) render();
          ensureReasons();
        } else softRefresh();
      });
    }
    document.addEventListener('cart:updated', softRefresh);

    render();
    mount();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        mount();
      });
    }).observe(mainCart, { childList: true, subtree: true });
    readCart()
      .then(function (cart) {
        state.cart = cart;
        render();
        ensureReasons();
      })
      .catch(function () {});
  }

  ready(function () {
    // CUI-ul altui cont nu rămâne pe browser (și nu-l citește widgetul de livrare la plată).
    readCui();
    // Favoritele nu mai sunt pe site (04.10.2026): copia listei lăsată pe browser de a șasea rundă nu mai folosește.
    try {
      localStorage.removeItem('grocera.favorite');
    } catch (error) {}
    try {
      cartExtras();
    } catch (error) {
      if (window.console) console.warn('[ga] coș', error);
    }
  });
})();
